module.exports = __webpack_public_path__ + "img/2012-2.8dca7bc4.jpeg";